import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#44855f',
        },
        secondary: {
            main: '#efb442',
        },
        tertiary: {
            main: '#040002',
        },
        quarternary: {
            main: '#F6F0E3',
        },
    },
});

export default theme;